<template>
  <v-card>
    <v-card-title>
      Quantidade de Acesso por Empresa
      <!-- Média Acesso X Usuário -->
    </v-card-title>
    <v-card-text v-show="!showCard">
      <div class="text-center ma-12" align="center">
        <v-progress-circular
          class=""
          :indeterminate="true"
          :rotate="0"
          :size="128"
          value="Loading"
          :width="8"
          color="light-blue"
          >{{ "Loading" }}</v-progress-circular
        >
      </div>
    </v-card-text>
    <v-card-subtitle> Total de {{ totalSession }} acessos </v-card-subtitle>
    <GraphicColumn
      v-if="showCard"
      :categories="categories"
      :titleY="titleY"
      :titleX="titleX"
      :chartSeries="chartSeries"
    />
    <GraphicLine
      v-if="false"
      :categories="categories"
      :titleY="titleY"
      :titleX="titleX"
      :chartSeries="chartSeries"
    />
  </v-card>
</template>

<script>
import { mapGetters } from "vuex";
import firebase from "@/plugins/firebase";
export default {
  components: {
    GraphicColumn: () => import("./GraphicColumn"),
    GraphicLine: () => import("./GraphicLine")
  },

  data() {
    return {
      categories: [],
      totalSession: 0,
      titleY: "Total de Acessos por Empresa",
      titleX: "Empresa",
      chartSeries: [
        {
          color: "#4285f4",
          name: "Acesso",
          data: [],
          showInLegend: false
        }
      ],
      showCard: false,
      date_init: "",
      date_end: "",
      isCompany: false,
      company: []
    };
  },
  computed: {
    ...mapGetters("appAnalytics", ["getFilter"]),
    ...mapGetters(["getEmpresas"])
  },
  watch: {
    getFilter(m, v) {
      this.showCard = false;
      this.init();
    }
  },

  methods: {
    async init() {
      var dataValue = [];
      var totalSession_local = 0;
      var dataCategorie = [];
      const callDate = this.getFilter;
      this.date_init = callDate.date[0];
      this.date_end = callDate.date[1];
      this.company = callDate.empresas;
      this.isCompany = callDate.withCompany;

      const app_analytics = firebase
        .functions()
        .httpsCallable("app_analytics/mediaAcessos");
      await app_analytics({
        date_init: this.date_init,
        date_end: this.date_end,
        isCompany: this.isCompany,
        company: this.company
      })
        .then(result => {
          var tmp = [];
          this.getEmpresas.forEach((e, c) => {
            tmp = [];
            tmp = result.data.filter(a => {
              return a.empresa == e.cnpj;
            });
            totalSession_local +=
              tmp.length > 0 ? Number(tmp[0].user_session) : 0;
            dataValue.push(tmp.length > 0 ? Number(tmp[0].user_session) : 0);
            dataCategorie.push(e.apelido);
          });
        })
        .catch(erro => {
          console.log(erro);
        });

      Promise.all(dataValue, dataCategorie, totalSession_local).then(a => {
        this.showCard = !this.showCard;
        this.categories = dataCategorie;
        this.chartSeries[0].data = dataValue;
        this.totalSession = totalSession_local;
      });
    }
  },

  created() {
    this.init();
  }
};
</script>

<style lang="scss"></style>
